import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {  GridPostParams } from 'common/models/utility-models/list-utility.model';
import { FeedbackMappingModel } from 'common/models/page-models/Feedback-Mapping/feedback-mapping-data-model';
import { FeedbackMappingGridParams, FeedbackMappingListingModel } from 'common/models/page-models/Feedback-Mapping/feedback-mapping-grid-model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { EditFeedbackTitleDataService } from './editFeedbackTitle-data.service';
import { DatePipe } from '@angular/common';


@Injectable({
    providedIn: 'root'
})
export class FeedbackMappingGridDataService extends GridDataService<FeedbackMappingListingModel, FeedbackMappingModel> {
     getDeleteUrl(): string {
        throw new Error('Method not implemented.');
    }
   
   
    constructor(http: SmApiService, protected override  ss: SystemService,private datePipe: DatePipe
    ) {
        super(API_URL.feedbackMappinggrid, http, ss);
    }

     getGridParams(param): GridPostParams {
        return new FeedbackMappingGridParams();
    }


    createInstance(): FeedbackMappingListingModel {
        return new FeedbackMappingListingModel();
    }
    
    override transformDataModel(apiRes: any, param) {
        super.transformDataModel(apiRes,param);
        apiRes[param].forEach(element => {
            element.display_datetime = this.datePipe.transform(element.display_datetime, 'dd-MM-yyyy hh:mm:ss');
        });
        return apiRes;
    }
}
